import { render, staticRenderFns } from "./problemsList.vue?vue&type=template&id=7f69c9dc&"
import script from "./problemsList.vue?vue&type=script&lang=js&"
export * from "./problemsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports